import axios from 'axios';

const apiBaseURL = window.APP_CONFIG.API_BASE_URL;
const publicClient = axios.create({ baseURL: `${apiBaseURL}/api`, timeout: 5000 });

const unwrap = (response) => {
  if (response.data?.code !== 200) {
    throw new Error(response.data?.message || 'The request could not be completed.');
  }
  return response.data.data;
};

export const fetchProjects = (language = 'en') => publicClient
  .get('/projects', { params: { lang: language } })
  .then(unwrap);
export const fetchProject = (slug, language = 'en') => publicClient
  .get(`/projects/${encodeURIComponent(slug)}`, { params: { lang: language } })
  .then(unwrap);
